import { connectorFactory } from 'components/app/connectorFactory'
import { CONSTS } from 'config/objectConst'

const appConnector = connectorFactory(CONSTS.EXTENSION_ID)

export { appConnector }
